module.exports = __webpack_public_path__ + "img/exec_comp_banner.e6521518.jpg";